import React from 'react';
import { WebinarAccess } from './pages/WebinarAccess';
export function App() {
  return <WebinarAccess data-id="element-0" data-mp="35ckaa75id2iz" />;
}